<style>
    table, th, td{
         border: solid 1px rgba(40,40,40,0.2);
         font-size:14px;
         padding:5px;
     }
     table{
         width: 100%;
     }
 </style>
<div class="row">
    <div class="col-12">
        <h2>Geles En Sachet</h2>
    </div>
    <div class="col-12">
        <table id="myTable">
            <tr class="header">
              <th style="width:50%;"><t1>Artículo</t1></th>
              <th style="width:10%;"><t1>Código</t1></th>
              <th style="width:40%;"><t1>Medidas</t1></th>
            </tr>
            <tr>
              <td><t2>GEL x 150 G</t2></td>
              <td><t2>GS001</t2></td>
              <td><t2>Largo: 15 cm, Ancho: 10 cm</t2></td>
            </tr>
            <tr>
              <td><t2>GEL x 300 G</t2></td>
              <td><t2>GS002</t2></td>
              <td><t2>Largo: 17,5 cm, Ancho: 15 cm</t2></td>
            </tr>
            <tr>
              <td><t2>GEL x 350 G</t2></td>
              <td><t2>GS003</t2></td>
              <td><t2>Largo: 19 cm, Ancho: 15 cm</t2></td>
            </tr>
            <tr>
              <td><t2>GEL x 500 G</t2></td>
              <td><t2>GS004</t2></td>
              <td><t2>Largo: 22,5 cm, Ancho: 15 cm</t2></td>
            </tr>
            <tr>
              <td><t2>GEL x 600 G</t2></td>
              <td><t2>GS005</t2></td>
              <td><t2>Largo: 25 cm, Ancho: 15 cm</t2></td>
            </tr>
            <tr>
              <td><t2>GEL x 800 G</t2></td>
              <td><t2>GS006</t2></td>
              <td><t2>Largo: 29,5 cm, Ancho: 15 cm</t2></td>
            </tr>
          </table>
    </div>
</div>